import { isNumber, isObject, isString } from "@videojs/utils/predicate";
//#region src/player-api.ts
/** Marker every player message carries, whichever way it travels. */
const PLAYER_MESSAGE_KEY = "x-tiktok-player";
const ERROR_AUTOPLAY = 3002;
const ERROR_NETWORK_CATEGORY = 2e3;
const ERROR_PLAYER_CATEGORY = 3e3;
const ERROR_CATEGORY_END = 4e3;
/** Whether a `message` event's data is one of the embed's; every frame posts here, so the marker tells them apart. */
function isTikTokPlayerMessage(data) {
	if (!isObject(data)) return false;
	const message = data;
	return !!message["x-tiktok-player"] && isString(message.type);
}
/** Whether a value is the pair `onCurrentTime` reports. */
function isTikTokCurrentTime(value) {
	return isObject(value) && isNumber(value.currentTime);
}
/** Whether a value is the payload `onPlayerError` reports. */
function isTikTokPlayerError(value) {
	return isObject(value) && isNumber(value.errorCode);
}
/** Build a command message. A command without a value must not carry one at all. */
function createTikTokPlayerCommand(type, value) {
	return {
		[PLAYER_MESSAGE_KEY]: true,
		type,
		...isNumber(value) && { value }
	};
}
//#endregion
export { ERROR_AUTOPLAY, ERROR_CATEGORY_END, ERROR_NETWORK_CATEGORY, ERROR_PLAYER_CATEGORY, PLAYER_MESSAGE_KEY, createTikTokPlayerCommand, isTikTokCurrentTime, isTikTokPlayerError, isTikTokPlayerMessage };
